import { environment } from './environment';

export const ROOT_URL = environment.ROOT_URL || 'http://localhost:8000';
export const API_URL = `${ROOT_URL}/api`;
export const MAX_IMAGE_NR = 5;
export const MIN_TEMP = 500; // declared in centidegrees for consistency with thrift v2
export const MAX_TEMP = 3500; // declared in centidegrees for consistency with thrift v2
export const POLLING_MAX_TICK_COUNT = 10;
export const POLLING_TIMEOUT = 1000;
export const POLLING_SELF_TEST_TIMEOUT = 10000;
export const CONSUMPTION_TEST_MIN_THRESHOLD = 5; // In watts
export const CONSUMPTION_TEST_MAX_THRESHOLD = 35; // In watts
export const LTE_CREDENTIALS = 'tiko_no_network';
export const ODOO_INST_STATES = {
    RUNNING: '3run',
};
export const ODOO_INST_TYPE = {
    NEW: '1',
    REPAIR: '2',
    UNINSTALL: '3',
};
export const CUSTOMER_PORTAL_URL =
    environment.CUSTOMER_PORTAL_URL || 'https://portal-beta.tiko.energy';
export const DEFAULT_LOCALE = environment.DEFAULT_LOCALE || 'en';

export const LOGIN_DEV_USERNAME = environment.LOGIN_DEV_USERNAME || '';
export const LOGIN_DEV_PASSWORD = environment.LOGIN_DEV_PASSWORD || '';
export const SKIP_LTE_CHECK = environment.SKIP_LTE_CHECK || false;
export const APP_NAME = environment.APP_NAME || 'tiko';
export const DEEPOMATIC_ARRAY_LENGTH = 30;
